import {CarMakes} from "../../../../../packages/utils/cars_routes/src/car_makes";
import {UMakeTypes} from "../../cars_data/cars_data";
import {UMakeKeys} from "../list/url_utils/tag_utils";

/** Makes that can appear as a single path segment in the current router regex. */
const routableMakeSlugs = new Set(CarMakes.filter((make) => /^[A-Za-z0-9]+$/.test(make)).map((make) => make.toLowerCase()));

/**
 * Maps API make labels (e.g. "Alfa Romeo") or slugs (e.g. "mercedesbenz") to route keys.
 */
export const getMakeSlug = (make: string): UMakeKeys | undefined => {
    const normalized = make.trim();
    if (!normalized) {
        return undefined;
    }

    const lower = normalized.toLocaleLowerCase("pl");
    const slug = (
        Object.prototype.hasOwnProperty.call(UMakeTypes, lower)
            ? lower
            : Object.entries(UMakeTypes).find(([, label]) => label.toLocaleLowerCase("pl") === lower)?.[0]
    ) as UMakeKeys | undefined;

    if (!slug || !routableMakeSlugs.has(slug)) {
        return undefined;
    }

    return slug;
};
